import { render, staticRenderFns } from "./SqlBox.vue?vue&type=template&id=1af1367c&scoped=true&"
import script from "./SqlBox.vue?vue&type=script&lang=js&"
export * from "./SqlBox.vue?vue&type=script&lang=js&"
import style0 from "./SqlBox.vue?vue&type=style&index=0&id=1af1367c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af1367c",
  null
  
)

export default component.exports